module.exports = __webpack_public_path__ + "img/map_jf_done.bb8b4731.png";